module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_maedori_02-6b360ed591e19234479faceeaaacccb4.webp";